import { URLS } from '@/utils/constants';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useAuth } from '../components/providers/preauth/AuthProvider';
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { replace, isReady, push } = useRouter();
  const { user, checkingAuthStatus, isEmailVerified } = useAuth();
  useEffect(() => {
    const checkAuth = async () => {
      if (!isReady || checkingAuthStatus) return;
      if (!user) {
        replace(URLS.auth);
        return;
      }
      const verified = await isEmailVerified();
      if (user && !verified) {
        push({
          pathname: URLS.signIn,
          query: {
            verifyEmail: 'true',
            email: user.email,
          },
        });
      }
    };
    checkAuth();
  }, [user, checkingAuthStatus, isReady, replace, push, isEmailVerified]);
  const [isVerified, setIsVerified] = useState(false);
  useEffect(() => {
    const checkVerification = async () => {
      if (user) {
        const verified = await isEmailVerified();
        setIsVerified(verified);
      } else {
        setIsVerified(false);
      }
    };
    checkVerification();
  }, [user, isEmailVerified]);
  return <>{user && isVerified ? children : null}</>;
};
export default ProtectedRoute;
